import React from 'react'
import Heading from './component/Heading';
import CoinSummaryPage from './component/CoinSummaryPage';
import './component/Crypto.css'
import Carousel1 from '../../Components/Carousel1';

function Track() {
  return (
    <>
      <Heading heading={"CoinList"} />
      <div className='w-11/12 min-w-[300px] max-w-[1280px] mx-auto mt-9'>
        <p className=' w-11/12 text-center text-zinc-600 font-bold text-2xl '>Trending Coins</p>
      <Carousel1/>
      </div>
      <div className='mt-9 flex  flex-1 justify-center items-center text-richblack-900 '>
        <CoinSummaryPage />
      </div>
    </>
  );

};
export default Track;